/**
 * Header di autenticazione per le chiamate al server (STU-57, STU-104).
 *
 * Il browser NON puo' portare una chiave condivisa: finirebbe nel bundle JS e
 * sarebbe leggibile da chiunque apra DevTools. L'unica credenziale che un
 * client pubblico puo' esibire e' il token dell'utente loggato.
 * La chiave condivisa resta per le chiamate server-to-server (Cloud Function).
 *
 * Non solleva mai: se il token non c'e' (utente non loggato, refresh in corso)
 * torna gli header di partenza. Chi decide se rifiutare e' il server — un
 * fallimento qui non deve trasformarsi in una schermata rotta.
 */
import { auth } from '@redux/firebase';

const withAuthHeaders = async (base = {}) => {
  try {
    const token = await auth?.currentUser?.getIdToken?.();
    if (token) {
      return { ...base, Authorization: `Bearer ${token}` };
    }
  } catch (error) {
    console.warn('[authHeaders] token non disponibile:', error?.message);
  }
  return base;
};

export default withAuthHeaders;
